import { jsx as l, jsxs as E } from "react/jsx-runtime";
import * as m from "react";
import { cn as a } from "../../../lib/utils.js";
const T = m.forwardRef(({ sections: r, activeSection: c, onSectionChange: s, variant: b = "sidebar", position: o = "right", offset: n = 100, smooth: x = !0, className: d }, i) => {
  var y;
  const [u, S] = m.useState(c || ((y = r[0]) == null ? void 0 : y.id) || ""), g = c !== void 0, f = g ? c : u;
  m.useEffect(() => {
    const e = () => {
      const t = window.scrollY + n;
      for (let p = r.length - 1; p >= 0; p--) {
        const w = r[p];
        if (!w)
          continue;
        const k = document.getElementById(w.id);
        if (k) {
          const A = k.offsetTop;
          if (t >= A) {
            const N = w.id;
            g || S(N), s == null || s(N);
            break;
          }
        }
      }
    };
    return window.addEventListener("scroll", e, { passive: !0 }), e(), () => window.removeEventListener("scroll", e);
  }, [r, n, g, s]);
  const v = (e) => {
    const t = document.getElementById(e);
    if (t) {
      const p = t.offsetTop - n + 20;
      x ? window.scrollTo({
        top: p,
        behavior: "smooth"
      }) : window.scrollTo(0, p);
    }
  }, h = {
    left: "fixed left-4 top-1/2 -translate-y-1/2",
    right: "fixed right-4 top-1/2 -translate-y-1/2",
    top: "fixed top-4 left-1/2 -translate-x-1/2",
    bottom: "fixed bottom-4 left-1/2 -translate-x-1/2"
  };
  return b === "dots" ? l("div", { ref: i, className: a("z-40 flex gap-2", o === "left" || o === "right" ? "flex-col" : "flex-row", h[o], d), children: r.map((e) => {
    const t = f === e.id;
    return l("button", { onClick: () => v(e.id), className: a("group relative w-3 h-3 rounded-full transition-all duration-300", t ? "bg-lpr-teal dark:bg-lpr-gold scale-125" : "bg-[var(--bg-muted)] hover:bg-lpr-teal/50 dark:hover:bg-lpr-gold/50"), title: e.label, children: l("span", { className: "absolute left-full ml-3 px-2 py-1 bg-lpr-charcoal text-white dark:bg-[var(--bg-surface)] dark:text-[var(--text-primary)] dark:border dark:border-[var(--border-color)] text-xs rounded shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap", children: e.label }) }, e.id);
  }) }) : b === "tabs" ? l("div", { ref: i, className: a("bg-[var(--bg-surface)] border border-[var(--border-color)] rounded-lg p-1 shadow-card", h[o], d), children: l("div", { className: a("flex gap-1", o === "left" || o === "right" ? "flex-col" : "flex-row"), children: r.map((e) => {
    const t = f === e.id;
    return l("button", { onClick: () => v(e.id), className: a("px-3 py-2 text-sm font-medium rounded-md transition-all duration-200", t ? "bg-lpr-teal dark:bg-lpr-gold text-white dark:text-lpr-charcoal shadow-card" : "text-[var(--text-secondary)] hover:text-[var(--text-primary)] hover:bg-[var(--bg-muted)]"), children: e.label }, e.id);
  }) }) }) : b === "minimal" ? l("nav", { ref: i, className: a("space-y-1", d), children: r.map((e) => {
    const t = f === e.id;
    return l("button", { onClick: () => v(e.id), className: a("block w-full text-left px-3 py-2 text-sm transition-colors duration-200", t ? "text-lpr-teal dark:text-lpr-gold font-semibold border-l-2 border-lpr-teal dark:border-lpr-gold bg-lpr-teal/5 dark:bg-lpr-gold/5" : "text-[var(--text-secondary)] hover:text-[var(--text-primary)]"), children: e.label }, e.id);
  }) }) : E("div", { ref: i, className: a("bg-[var(--bg-surface)] border border-[var(--border-color)] rounded-lg p-4 shadow-card", h[o], d), children: [l("h4", { className: "text-sm font-semibold text-[var(--text-primary)] mb-3", children: "Contents" }), l("nav", { className: "space-y-1", children: r.map((e) => {
    const t = f === e.id;
    return l("button", { onClick: () => v(e.id), className: a("block w-full text-left px-3 py-2 text-sm rounded-md transition-all duration-200", t ? "bg-lpr-teal dark:bg-lpr-gold text-white dark:text-lpr-charcoal shadow-card" : "text-[var(--text-secondary)] hover:text-[var(--text-primary)] hover:bg-[var(--bg-muted)]"), children: e.label }, e.id);
  }) })] });
});
T.displayName = "ScrollSpy";
const B = (r, c = 100) => {
  var o;
  const [s, b] = m.useState(((o = r[0]) == null ? void 0 : o.id) || "");
  return m.useEffect(() => {
    const n = () => {
      const x = window.scrollY + c;
      for (let d = r.length - 1; d >= 0; d--) {
        const i = r[d];
        if (!i)
          continue;
        const u = document.getElementById(i.id);
        if (u && x >= u.offsetTop) {
          b(i.id);
          break;
        }
      }
    };
    return window.addEventListener("scroll", n, { passive: !0 }), n(), () => window.removeEventListener("scroll", n);
  }, [r, c]), s;
};
export {
  T as ScrollSpy,
  B as useScrollSpy
};
//# sourceMappingURL=ScrollSpy.js.map
